// App.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import NoMatch from "./pages/NoMatch";
import SignInPage from "./pages/authentification/SignInPage";
import { UserAuthContextProvider } from "./context/UserAuthContext";
import { ThemeProvider } from "@emotion/react";
import theme from "./styles/styleTheme";
import HomePage from "./pages/HomePage";
import ProtectedRoute from "./components/ProtectedRoute";
import "./index.css";
import { DebugContextProvider } from "./context/DebugContext";
import PropertyOverview from "./pages/PropertyOverview";
import { FilteredPropertiesContextProvider } from "./context/FilteredPropertiesContext";
import CreateTenantAccount from "./pages/CreateTenantAccount";
import TenantCheck from "./pages/Screening";
import VerifyAccount from "./pages/VerifyAccount";
import PaymentConfirmation from "./pages/PaymentConfirmation";
import AccountConfirmation from "./pages/authentification/CreateAccountCheck";
import PremiumUpgrade from "./pages/PremiumUpgrade";
import ForgotPassword from "./pages/authentification/ForgotPassword";
import ForgotPasswordConfirmation from "./pages/authentification/ForgotPasswordConfirmation";
import ResetPassword from "./pages/authentification/ResetPassword";
import Profile from "./pages/protected/Profile";
import ProfileOverview from "./components/profile/ProfileOverview";
import Candidatures from "./pages/Candidatures";
import NAV from "./utils/nav.const";
import Property from "./pages/Property";
import Datakeeper from "./pages/Datakeeper";
import ScreeningProfiles from "./components/profile/ScreeningProfiles";
import ScreeningProfile from "./components/ScreeningProfiles/ScreeningProfile";
import { AgentGroupsContextProvider } from "./context/AgentGropusContext";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <UserAuthContextProvider>
        <DebugContextProvider>
          <AgentGroupsContextProvider>
            <FilteredPropertiesContextProvider>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<HomePage />} />
                  <Route path={NAV.HOME} element={<HomePage />} />
                  <Route path={NAV.SIGNIN} element={<SignInPage />} />
                  <Route
                    path={NAV.FORGOT_PASSWORD}
                    element={<ForgotPassword />}
                  />
                  <Route
                    path={NAV.FORGOT_PASSWORD_CONFIRMATION}
                    element={<ForgotPasswordConfirmation />}
                  />
                  <Route
                    path={`${NAV.RESET_PASSWORD}/:username/:code`}
                    element={<ResetPassword />}
                  />
                  <Route
                    path={NAV.PROPERTY_OVERVIEW}
                    element={<PropertyOverview />}
                  />
                  <Route
                    path={"datakeeper/:encodedJson/"}
                    element={<Datakeeper />}
                  />
                  {/* <Route path={`${NAV.COMPLEX}`} element={<Complex />} />
                <Route
                  path={`${NAV.COMPLEX}/:slug`}
                  element={<ComplexType />}
                /> */}
                  {/* <Route
                  path={`${NAV.COMPLEX}/:complexType/:slug`}
                  element={<ComplexPropertyDetails />}
                /> */}
                  <Route
                    path={`${NAV.VERIFY_ACCOUNT}/:username/:code`}
                    element={<VerifyAccount />}
                  />
                  <Route
                    path={`${NAV.PROPERTY_DETAILS}/:slug`}
                    element={<Property />}
                  />
                  <Route
                    path={NAV.CREATE_TENANT_ACCOUNT}
                    element={<CreateTenantAccount />}
                  />
                  <Route
                    path={NAV.ACCOUNT_CONFIRMATION}
                    element={<AccountConfirmation />}
                  />
                  <Route
                    path={`${NAV.TENANT_CHECK}/:candidateId`}
                    element={<TenantCheck />}
                  />
                  <Route
                    path={`${NAV.PAYMENT_CONFIRMATION}/:userId`}
                    element={<PaymentConfirmation />}
                  />
                  <Route
                    path={NAV.PREMIUM_UPGRADE}
                    element={<PremiumUpgrade />}
                  />
                  <Route element={<ProtectedRoute />}>
                    <Route path={NAV.PROFILE} element={<Profile />}>
                      <Route index element={<ProfileOverview />} />
                      <Route
                        path={NAV.PROFILE_OVERVIEW}
                        element={<ProfileOverview />}
                      />
                      <Route
                        path={NAV.PREMIUM_UPGRADE}
                        element={<PremiumUpgrade />}
                      />
                      <Route
                        path={NAV.APPLICATIONS}
                        element={<Candidatures />}
                      />
                      <Route
                        path={NAV.SCREENING_PROFILE}
                        element={<ScreeningProfiles />}
                      />
                    </Route>
                    <Route
                      path={`${NAV.SCREENING_PROFILE}/:profileId`}
                      element={<ScreeningProfile />}
                    />
                  </Route>

                  <Route path="*" element={<NoMatch />} />
                </Route>
              </Routes>
            </FilteredPropertiesContextProvider>
          </AgentGroupsContextProvider>
        </DebugContextProvider>
      </UserAuthContextProvider>
    </ThemeProvider>
  );
};

export default App;
